<template>
  <!-- 上报 -->
  <div class="container">
    <!-- <div class="item line_bottom">
      <div class="left">
        <span>退货单号</span>
        <span>{{orderNumber}}</span>
      </div>
      <span>></span>
    </div> -->

    <div>
      <div class="item line_bottom">
        <div class="left">
          <p><span>上报机构</span><span class="xinghao">*</span></p>
          <span class="result_style">{{ typeValue }}</span>
        </div>
      </div>
      <div class="supplement-box">
        <span class="title">上报原因</span>
  
         <van-field
              class="textarea"
              v-model="content"
              autosize
              type="textarea"
              maxlength="500"
              placeholder="请输入"
            />
        <div class="tip">{{ content.length }}/500</div>
      </div>

    </div>
    <div class="btn">
      <span @click="confirm" :class="{'active':change}">确定</span>
    </div>
  </div>
</template>
<script>
    import util from '../../../../utils/common';
    import api from '../../../../service/modules/refund.js';
    // import { Toast } from "mint-ui";
    export default {
        components: {},
        data () {
            return {
                typeValue: '请选择监理中心',
                content: '',
                flowId: this.$router.currentRoute.query.flowId,
                orderNumber: this.$router.currentRoute.query.number,
                orgId: this.$store.state.refund.userInfo.orgId,
                isOriginHei: true,
                documentHeight: document.documentElement.clientHeight, // 默认屏幕高度
                isFlag: true
            };
        },
        computed: {
            change () {
                if ((this.code !== '') & (this.content.trim().length > 0)) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        mounted () {
            window.onresize = () => {
                return (() => {
                    if (this.documentHeight > document.documentElement.clientHeight) {
                        this.isOriginHei = false;
                    } else {
                        this.isOriginHei = true;
                    }
                })();
            };
        },
        created () {
            this.getParentOrg();
        },
        methods: {
            getParentOrg () {
                api.getSelfParentOrg().then(res => {
                    if (res.ret === 0) {
                        this.typeValue = res.data.name
                    } else {
                        this.typeValue = ''
                    }
                })
                // api.parentOrg({ orgId: this.orgId }).then(res => {
                //   if (res.ret === 0) {
                //     if (res.data) {
                //       this.typeValue = res.data.name;
                //     } else {
                //       this.typeValue = ''
                //     }
                //   }
                // });
            },
            getReport () {
                if (!this.typeValue) {
                    return this.$Toast({
                        message: '无法再上报'
                    });
                }
                // 上报申请
                api.report({ flowId: this.flowId, content: this.content }).then(res => {
                    if (res.ret === 0) {
                        this.$Toast({
                            message: '上报成功'
                        });
                        this.isOriginHei = false;
                        setTimeout(() => {
                            this.$router.back();
                        }, 1500);
                    } else {
                        // Toast({
                        //     message: res.msg
                        // })
                    }
                });
            },
            getTypeValue (value) {
                this.typeValue = value.text;
                this.code = value.code;
            },
            confirm () {
                if (!this.content) {
                    this.$Toast({
                        message: '请填写原因'
                    });
                } else {
                    if (this.isFlag) {
                        this.getReport();
                        this.isFlag = false;
                    }
                }
            }
        }
    };
</script>
<style scoped  lang="less">
.container {
  width: 100%;
  padding: 0 12px;
  min-height: 100vh;
  // position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom: 34px;
  .item {
    display: flex;
    display: -webkit-flex;
    padding: 24px 0;
    justify-content: space-between;
    -webkit-justify-content: space-between;
    .left {
      width: 100%;
      display: flex;
      justify-content: space-between;
      span:nth-child(1) {
        display: inline-block;
      }
      .xinghao {
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #F94F4E;
        margin-left: 5px;
      }
      span {
        font-size: 14px;
        color: #666666;
      }
      .result_style {
        color: #171A1D;
      }
    }
  }
  .supplement-box {
    position: relative;
    padding: 16px 0 0;
    .title {
      font-size: 14px;
      color: #666666;
      margin-bottom: 12px;
      &::after{
        content: '*';
        font-size: 14px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #F94F4E;
        margin-left: 5px;
      }
    }
    /deep/.textarea {
      width: 100%;
    
      background: #f8f9fb;
      padding: 16px 4px 16px 16px;
      border-radius: 4px 4px 0 0;
      border: 0;
      font-size: 14px;
      line-height: 20px;
      box-sizing: border-box;
      margin-top: 16px;
      .van-field__control {
        min-height: 120px;
        max-height: 320px;
      }
       .van-field__control::-webkit-scrollbar {
              width: 3px;
          }
          .van-field__control::-webkit-scrollbar-thumb {
              background: #E4E5E8;
          }
          .van-field__control::-webkit-scrollbar-track {
              background: #F8F9FB;
          }
    }
    .tip {
      text-align: right;
      padding: 10px 16px 16px 0;
      background: #f8f9fb;
      width: 100%;
      position: relative;
      top: -15px;
      font-size: 14px;
      color: #cccccc;
      border-radius: 0 0 4px 4px;
      line-height: 25px;
    }
  }
  // .result {
  //   .info {
  //     display: inline-block;
  //     padding: 22px 0;
  //     font-size: 15px;
  //     color: #4a4a4a;
  //     &::after{
  //       content: '*';
  //       color: red;
  //       margin-left: 3px;
  //     }
  //   }
  //   .content {
  //     width: 100%;
  //     height: 180px;
  //     background-color: #f9f9f9;
  //     border: 0;
  //     outline: none;
  //     resize: none;
  //     padding: 16px 0 0 16px;
  //     box-sizing: border-box;
  //     // color:#D8D8D8;
  //     font-size: 15px;
  //   }
  // }
  .btn {
    width: 100%;
    height: 50px;
    // padding: 0 12px;
    // position: absolute;
    // left: 0;
    // bottom: 34px;
    span {
      width: 100%;
      height: 100%;
      display: inline-block;
      background-color: @base-color;
      opacity: 0.5;
      text-align: center;
      line-height: 50px;
      color: 16px;
      font-size: 16px;
      color: #fff;
      border-radius: 3px;
    }
    .active {
      opacity: 1;
    }
  }
}
</style>
